// extracted by mini-css-extract-plugin
module.exports = {"label":"inputBlock_label__cYgUr","extraLabel":"inputBlock_extraLabel__133fr","text":"inputBlock_text__IfXk1","required":"inputBlock_required__3bKb0"};
    if(module.hot) {
      // 1785568532895
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  